import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Navigation from './components/Navigation'
import StatusPanel from './components/StatusPanel'
import HomePage from './pages/HomePage'
import ProductsPage from './pages/ProductsPage'
import AboutPage from './pages/AboutPage'
import CartPage from './pages/CartPage'

function App() {
  return (
    <div className="app">
      <Header />
      <Navigation />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/documents" element={<AboutPage />} />
        <Route path="/cart" element={<CartPage />} />
      </Routes>
      
      <StatusPanel />
    </div>
  )
}

export default App
